import appStore from "store";
import api from "./api";

const store = {
  namespaced: true,
  state: {
    codelist: [],
    channellist:[],
    channeInfolist:[],
    updatePosterDialog: false,
    totalCount: 0,
    infoTotal: 0,
  },
  getters: {
   filterList:state=>state.codelist
  },
  mutations: {
    setcodelist(state, payload) {
      state.codelist = payload;
    },
    setchannellist(state, payload) {
      state.channellist = payload;
    },
    setChanneInfolist(state, payload) {
      state.channeInfolist = payload.list;
      state.infoTotal=payload.totalCount
    },

    setupdatePosterDialog(state, payload) {
      state.updatePosterDialog = payload;
    },
    setTotalCount(state,payload){
      state.totalCount=payload
    }
  },
  actions: {
    async getUrlList({commit},params){
      const res=await api.getUrlList(params)
      commit('setchannellist',res.data.list)
      commit('setTotalCount',res.data.totalCount)
      return res
    },

    async delOne({ commit }, data) {
      const res = await api.delOne(data.id);
      return res;
    },
    async addOne({ commit }, data) {
      const res = await api.addOne(data);
      return res;
    },
  async  updateOne({commit},data){
      const res=await api.updateUrl(data)
      return res
    },
  async  getChannelInfo({commit},data){
      const res=await api.getChannelInfo(data)
      console.log('resss',res);
      if(res.code==0){
        commit('setChanneInfolist',res.data)
        return res
      }
      
    }

  },
};

appStore.registerModule("channel", store);
